import BurgerUI from "./BurgerUI";
import "../style/Header.css";

function Header({ goTo, toggleNav, displayNav }) {  
  return (
    <>
      <header>
          <div id="header-desktop" className="header">
            <nav id="header-nav" className="header-part">
              <button className="nav-button" onClick={()=>goTo("salon")}>Salon</button>
              <button className="nav-button" onClick={()=>goTo("prestaTarifs")}>Prestations & Tarifs</button>
            </nav>
            <div id="header-logo" className="header-part">
              <img className="mini-logo" src="/img/mini_logo.png" alt="L'appart d'Enzo"/>
            </div>
            <a href="https://www.planity.com/lappart-denzo-92120-montrouge" id="header-nav-bis" className="header-part">
              <button className="nav-button" id="rdv-button">Prendre RDV</button>
            </a>
          </div>
          <div id="header-mobile" className="header">
            <div id="header-logo" className="header-part">
              <img className="mini-logo" src="/img/mini_logo.png" alt="L'appart d'Enzo"/>
            </div>
            <div id="header-burger" className="header-part" onClick={toggleNav}>
              <BurgerUI isChecked={displayNav} />
            </div>
            {displayNav && (
              <nav id="header-nav-mobile">
                <div id="header-pages-button">
                  <button className="nav-button" onClick={()=>goTo("salon")}>Salon</button>
                  <button className="nav-button" onClick={()=>goTo("prestaTarifs")}>Prestations & Tarifs</button>
                </div>
                <a href="https://www.planity.com/lappart-denzo-92120-montrouge">
                <button className="nav-button">
                  <span className="rdv-button">Prendre RDV</span>
                </button>
                </a>
              </nav>
            )}
          </div>
      </header>
      <div className="blankspace" />
    </>
  );
}

export default Header;
